import { AlertTriangle, Skull } from 'lucide-react';
import type { RerankerDamage as RerankerDamageType } from '@/types/dashboard';

interface RerankerDamageProps {
  damage: RerankerDamageType[];
}

export function RerankerDamage({ damage }: RerankerDamageProps) {
  if (damage.length === 0) return null;

  return (
    <div className="rounded-xl border border-red-500/40 bg-red-500/10 p-5 backdrop-blur-xs">
      {/* Warning Banner */}
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 rounded-lg bg-red-500/20">
          <AlertTriangle className="h-5 w-5 text-red-400" />
        </div>
        <div>
          <h3 className="text-base font-bold text-red-400">
            Reranker Damage Report
          </h3>
          <p className="text-xs text-red-400/70">
            {damage.length} true positive{damage.length !== 1 ? 's' : ''} killed
            by the reranker
          </p>
        </div>
      </div>

      {/* Killed Venues List */}
      <div className="space-y-2">
        {damage.map((venue) => (
          <div
            key={venue.name}
            className="flex items-start gap-3 p-3 rounded-lg bg-red-500/10 border border-red-500/20"
          >
            <Skull className="h-4 w-4 text-red-400 mt-0.5 shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3 mb-1">
                <span className="font-semibold text-sm text-foreground">
                  {venue.name}
                </span>
                <span className="text-xs font-bold tabular-nums text-red-400 bg-red-500/20 px-2 py-0.5 rounded">
                  Score: {venue.rerank_score?.toFixed(1) ?? '--'}
                </span>
              </div>
              <div className="text-xs text-muted-foreground mb-1">
                <span className="font-medium text-foreground/60">Evidence: </span>
                {venue.evidence}
              </div>
              <div className="text-xs text-red-400/80">
                <span className="font-medium text-red-400/60">Rerank reason: </span>
                {venue.rerank_reason}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
